import { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, message, Modal, PageHeader, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";

import { fbFunctions } from "../../data/Firebase";
import useTranslation from "../../intl/useTranslation";
import removeTrailingParam from "../../lib/removeTrailingParam";

const { Text } = Typography;

const DeleteMission = ({ mission }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const location = useLocation();

	const [deleting, setDeleting] = useState(false);
	const [deleteModal, setDeleteModal] = useState(false);

	const deleteMission = async () => {
		setDeleting(true);
		const deleteFunction = httpsCallable(fbFunctions, "deleteMission");
		await deleteFunction({ missionId: mission.id });
		setDeleting(false);
		message.success(t("missions.deleteSuccess"));
		navigate(removeTrailingParam(location.pathname));
	};

	return (
		<>
			<Button
				type="primary"
				className="btn-reject"
				onClick={() => setDeleteModal(true)}
				loading={deleting}
			>
				{t("missions.delete")}
			</Button>
			<Modal
				open={deleteModal}
				onOk={deleteMission}
				confirmLoading={deleting}
				onCancel={() => setDeleteModal(false)}
				okText={t("missions.confirm")}
				cancelText={t("missions.cancel")}
				className="influencer-confirm-modal"
			>
				<Text>{t("missions.delete")}</Text>
				<PageHeader
					title={mission.title}
					className="influencer-title-small"
					avatar={{ src: mission.image, icon: <UserOutlined /> }}
				/>
			</Modal>
		</>
	);
};

export default DeleteMission;
